<template>
  <div
    :class="{
      'section': hasNoModifier,
      'section--no-bottom-padding': noBottomPadding,
      'section--no-top-padding': noTopPadding,
      'section--hero': isHero,
    }">
    <slot />
  </div>
</template>

<script>
export default {
  name: "Section",
  props: {
    noBottomPadding: { type: Boolean, default: false },
    noTopPadding: { type: Boolean, default: false },
    isHero: { type: Boolean, default: false }
  },
  computed: {
    hasNoModifier() {
      return !this.noBottomPadding && !this.noTopPadding && !this.isHero;
    }
  }
};
</script>
